import { cn } from "@/lib/utils"

interface LogoProps {
  className?: string
  variant?: "default" | "gradient"
}

export function Logo({ className, variant = "default" }: LogoProps) {
  if (variant === "gradient") {
    return (
      <span
        className={cn(
          "text-2xl font-bold tracking-tight bg-gradient-to-r from-emerald-500 via-purple-500 to-pink-500 bg-clip-text text-transparent",
          className
        )}
      >
        ardax
      </span>
    )
  }

  return (
    <span
      className={cn(
        "text-2xl font-bold tracking-tight text-purple-600 dark:text-purple-400",
        className
      )}
    >
      ardax
    </span>
  )
}
